import AsyncStorage from '@react-native-async-storage/async-storage';
import { AesUtil } from './AesUtil';
import { GLOBAL_IV, GLOBAL_SALT } from '../config/Constant';
import { setGoHome, setIsShownWelcomeScreen, setOpenChat, setProceedHotelSelection, setRedirectToTabId, setShowLoginModal } from '../Redux/Reducers/appConfigReducer';
import { setProceedLoginToTheApp, setRenderLoader } from '../Redux/Actions/appConfigAction';
import { setCurrentWidget } from '../Redux/Reducers/deviceConfigReducer';
import { setRedirectInfo } from '../Redux/Reducers/deeplinkReducer';
import { Linking, Platform } from 'react-native';
import { CHECK_IN } from '../navigation/StackNavigator/routes';
import { setGuestRoomData } from '../Redux/Reducers/guestRoomReducer';


export const redirectToDeepLink = () => {
    const deepLinkVar = process.env.REACT_APP_DEEPLINK_CONFIG
      ? process.env.REACT_APP_DEEPLINK_CONFIG.toLowerCase()
      : process.env.REACT_APP_CLIENT_CONFIG.split("_")[1].toLowerCase();
  
    let deeplinkConstant = `https://${deepLinkVar}.s3.amazonaws.com/static/redirect.html?downloadApp=True&eventName=${Platform.OS == "web" ? 'WEB_APP_CLICK' : 'NATIVE_APP_CLICK'}`;
  
    Linking.openURL(deeplinkConstant).catch(err => console.log("Failed to open URL:", err));
};

export const handleDeepLinkAction = (eventData, navigation) => {
    return async (dispatch, getState) => {

        const {  shownWelcomeScreen } = getState().appConfigSlice

        const { webAppWidgetsInfo } = getState().deviceConfigSlice;
        const { allowUserLoginViaFindingReservation } = webAppWidgetsInfo?.appConfigs || {};

        if(!eventData?.params || Object.keys(eventData?.params).length == 0){
            return;
        }

        let aesUtil = new AesUtil(128, 1000);
        const { isLoggedIn } = getState().appConfigSlice;
        
        const hotel_code = eventData.params.hotel ? eventData.params.hotel : null
        const current_hotel_code =  getState().appConfigSlice.clientId?.replace("GJ_", "").toUpperCase();
        

        if(hotel_code && hotel_code != current_hotel_code){
            dispatch(setProceedHotelSelection({init: true, hotel_Code: hotel_code}))
            return;
        }

        const loginAuthToken = eventData.params.loginAuthToken;
        if(loginAuthToken && !isLoggedIn){
            let loginGuestInfo = JSON.parse(aesUtil.decrypt(GLOBAL_SALT, GLOBAL_IV, "1234567891234567", loginAuthToken ));
            dispatch(setProceedLoginToTheApp(true, { lastName: loginGuestInfo?.lastName, roomNumber: loginGuestInfo?.roomNumber, checkinDate: loginGuestInfo?.checkinDate, confirmationNumber: loginGuestInfo?.confirmationNumber  }));
            return;
        }

        dispatch(setRedirectInfo({}));


        const guestDetailsToken = eventData.params.guestDetailsToken;
        if(guestDetailsToken){
            let checkInGuestPreInfo = atob(guestDetailsToken);

            if(checkInGuestPreInfo) {
                checkInGuestPreInfo = JSON.parse(checkInGuestPreInfo);
                dispatch(setGuestRoomData({
                    guestDetails: {
                        lastName: checkInGuestPreInfo?.lastName || '',
                        roomNumber: checkInGuestPreInfo?.roomNumber || '',
                        confirmationNumber: checkInGuestPreInfo?.confirmationNumber || checkInGuestPreInfo?.bookingNumber || '',
                        checkinDate: checkInGuestPreInfo?.checkinDate || '',
                    }
                }));
            }
        }

        if(!shownWelcomeScreen){
            setTimeout(() => {
                dispatch(setIsShownWelcomeScreen(true));
                dispatch(setGoHome(true));
            }, 0);
        }

        setTimeout(() => {
        // navigate to required bottom tab
        const bottomTabId = eventData?.params?.bottomTabId;
        if(bottomTabId) dispatch(setRedirectToTabId(bottomTabId));
        
        // navigate to required screen
        const appPath = eventData?.params?.appPath;
        const storeSku = eventData?.params?.storeSku;
        const { currentLayout } = getState().deviceConfigSlice;
        const widgetList = currentLayout?.scrollableWidgets || [];

        if (appPath && widgetList.length > 0) {
            if(appPath == "chat"){
                dispatch(setOpenChat(true));
                return;
            }

            if(appPath.toLowerCase() == "findres" || (appPath == CHECK_IN && allowUserLoginViaFindingReservation)){
                dispatch(setShowLoginModal(true));
                return;
            }
            
            dispatch(setCurrentWidget({
                widgetType: "deeplink",
                storeSku: storeSku
            }));
            navigation.navigate(appPath)
        }
    }, 500);
    }
}